/**
 * Shared translation context for **InHouseStats (IHS)** and **PreMatchStats (PMS)**.
 *
 * Logic is aligned with the former ihs-widget implementation: same provider, same `useTranslations` proxy
 * and fallbacks. Changes here affect both widgets.
 */

import React, { createContext } from 'react';
import defaultTranslations from './defaultTranslations';

type TranslationContextType = {
  translations: typeof defaultTranslations;
};

export const TranslationContext = createContext<TranslationContextType>({
  translations: defaultTranslations,
});

export const TranslationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const contextValue: TranslationContextType = {
    translations: defaultTranslations,
  };

  return <TranslationContext.Provider value={contextValue}>{children}</TranslationContext.Provider>;
};
